import { defineMessages } from 'react-intl'

export const claimHomeModalMessages = defineMessages({
  ctaBtn: {
    id: 'claimHomeModal.ctaBtn',
    description: 'CTA button on modal allowing to claim home',
    defaultMessage: 'Add Home',
  },
  title: {
    id: 'claimHomeModal.title',
    description: 'A title of modal allowing to claim home',
    defaultMessage: 'Add Home',
  },
  msg: {
    id: 'claimHomeModal.msg',
    description: 'A message shown on modal allowing to claim home',
    defaultMessage:
      'Contact an Admin user of a home to provide you with a unique claim code to add their home. You can also add homes by assigning inventory to a new home.',
  },
  claimCodeInput: {
    id: 'claimHomeModal.claimCodeInput',
    description: 'A placeholder for code shown on modal allowing to claim home',
    defaultMessage: 'Home claim code',
  },
  jobNameInput: {
    id: 'claimHomeModal.jobName',
    description:
      'A placeholder for job name shown on modal allowing to claim home',
    defaultMessage: 'Job name',
  },
})
